import styled from "styled-components";

export const LobbyGridDefaultBox = styled.div`
    overflow: hidden;

    // This is for CLS purpose, we want to make sure there is no 'jump' of the footer when lazy loaded swipers loads
    padding-bottom: 300px;

    max-width: 100%;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
      width: 100%;
    }
`;